/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateTuberculinTestDtoInterpretation =
  (typeof CreateTuberculinTestDtoInterpretation)[keyof typeof CreateTuberculinTestDtoInterpretation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTuberculinTestDtoInterpretation = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  NOT_EXECUTED: 'NOT_EXECUTED',
  PENDING: 'PENDING',
  NONE: 'NONE',
} as const;
